import type { FormFlowStep } from '../../../../../types/formFlow';
import type { WorkerRegistryCommittedEntry } from './workerRegistryTypes';

/** Shown only when the employee entered construction experience years (not “no work experience”). */
export const WORKER_REGISTRY_PREVIOUS_JOB_FIELD_NAMES = [
  'previousCompanyName',
  'previousCompanyPrefecture',
  'workStartedDate',
  'workEndedDate',
] as const;

const PREVIOUS_JOB_FIELD_SET = new Set<string>(WORKER_REGISTRY_PREVIOUS_JOB_FIELD_NAMES);

export function workerRegistryHasWorkExperience(rawYears: string | undefined | null): boolean {
  return (rawYears ?? '').trim().length > 0;
}

/** Uses committed answers only (in-progress draft values must not shrink the step list). */
export function workerRegistryIncludePreviousJobSteps(
  committed: WorkerRegistryCommittedEntry[]
): boolean {
  const expCommit = committed.find((c) => c.fieldName === 'constructionExperienceYears');
  if (!expCommit) {
    return true;
  }
  return workerRegistryHasWorkExperience(expCommit.rawValue);
}

export function workerRegistryActiveSteps(
  allSteps: FormFlowStep[],
  committed: WorkerRegistryCommittedEntry[]
): FormFlowStep[] {
  if (workerRegistryIncludePreviousJobSteps(committed)) {
    return allSteps;
  }
  return allSteps.filter((s) => !PREVIOUS_JOB_FIELD_SET.has(s.fieldName));
}

export function workerRegistryClearPreviousJobAnswers(
  answers: Record<string, string>
): Record<string, string> {
  const next = { ...answers };
  for (const key of WORKER_REGISTRY_PREVIOUS_JOB_FIELD_NAMES) {
    delete next[key];
  }
  return next;
}

export function workerRegistryStepByFieldName(
  allSteps: FormFlowStep[],
  fieldName: string
): FormFlowStep | undefined {
  return allSteps.find((s) => s.fieldName === fieldName);
}

export function workerRegistryCommittedWithoutPreviousJob(
  committed: WorkerRegistryCommittedEntry[]
): WorkerRegistryCommittedEntry[] {
  return committed.filter((c) => !PREVIOUS_JOB_FIELD_SET.has(c.fieldName));
}
